import * as React from 'react';
import {Icon} from "semantic-ui-react";
import {TDerivateIconProps, DerivateUtils} from './DerivateUtils';
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";

interface DerivateProps extends IVirtualizedTableCellComponentProps {
    isNewGridTable?: boolean;
}

function DerivateComponent(props: DerivateProps) {
    // Cache derivates array for performance
    const derivatesArr = props.derivates ? Array.from(props.derivates) : [];

    return (
        <React.Fragment>
            {
                derivatesArr.map((item) => {
                    // item[0] is the key, item[1] is the value
                    const valueObj = props.value[item[0]];
                    const hasMissing = props.missingPDiPAMTBs && props.missingPDiPAMTBs.has(item[1]);
                    const derivateIconProps: TDerivateIconProps = DerivateUtils.getDerivateAssignmentIconProps(valueObj, hasMissing);

                    const colorMap = props.derivateToColorMap && props.derivateToColorMap[item[0]];
                    const background = colorMap ? colorMap + "70" : "unset";

                    return (
                        <div
                            key={props.rowIndex + item[1]}
                            className='grid-body-derivate-cell grid-border-right'
                            style={{
                                background: background,
                                boxShadow: "initial",
                                height: props.isNewGridTable ? 100 : 'initial',
                            }}
                        >
                            <Icon
                                className={derivateIconProps.name === "close" ? "invisible" : "margin--0"}
                                name={derivateIconProps.name}
                                size={derivateIconProps.size}
                                color={derivateIconProps.color}
                            />
                            <sup className={"font-weight--bold"} style={{ color: derivateIconProps.color }}>
                                {derivateIconProps.supIconValue}
                            </sup>
                        </div>
                    );
                })
            }
        </React.Fragment>
    );
}

const Derivate = React.memo(DerivateComponent);

export default Derivate;



// WEBPACK FOOTER //
// ./src/components/Table/components/derivate/Derivate.tsx